/**
 * Сегмент тулбара: плашка подписи слева, варианты кнопками справа.
 *
 * Вид — тот же, что у `Combo`, `PeriodPicker` и `WindowPicker`: серая плашка
 * названия и высота 32 px, иначе строка тулбара читалась бы двумя разными
 * наборами контролов. Заведён 16.09.26, когда шестерёнка раздела «Товары» ушла в
 * тулбар (спека — `docs/specs/2026-09-16-products-toolbar-rows-design.md`).
 *
 * ВЫБОР ЗАДАЁТ ПРЕДИКАТ, А НЕ ЗНАЧЕНИЕ: одна вёрстка на одиночный выбор
 * (площадка, порядок, фильтры, вид) и на множественный (набор плитки). Соседние
 * кнопки разделены линией — без неё две отмеченные подряд слились бы в полосу.
 */

export type SegmentOption<T extends string> = {
  value: T;
  label: string;
  title?: string;
};

export function Segmented<T extends string>({
  label,
  title,
  options,
  isOn,
  onPick,
  annot,
}: {
  label: string;
  /** Подсказка плашки подписи — пояснение ко всей группе. */
  title?: string;
  options: SegmentOption<T>[];
  isOn: (value: T) => boolean;
  onPick: (value: T) => void;
  annot?: string;
}) {
  return (
    <div
      className="flex h-8 max-w-full overflow-x-auto rounded-[var(--radius-ui)] border border-border bg-bg text-[12.5px]"
      data-annot={annot ?? label}
    >
      <span
        className="flex flex-none items-center whitespace-nowrap border-r border-border bg-bg-subtle px-2 text-[11.5px] text-fg-faint"
        title={title}
      >
        {label}
      </span>
      {options.map((o, i) => {
        const on = isOn(o.value);
        return (
          <button
            key={o.value}
            type="button"
            aria-pressed={on}
            title={o.title}
            onClick={() => onPick(o.value)}
            className={
              "flex-none whitespace-nowrap px-2.5 " +
              (i > 0 ? "border-l border-border " : "") +
              (on ? "bg-accent/10 font-medium text-accent-text" : "text-fg-muted hover:bg-bg-hover hover:text-fg")
            }
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
